export default __webpack_public_path__ + "img/dancingman.c636bdcf.gif";